export enum UtilizationValue {
    Warning,
    ExceedsNumber,
    GracePeriod,
    NoWarning
}
